export default {
    setCurrentChannel (state, data) {
        state.currentChannel = data
    },
    setIsOpenChat (state, isOpenChat) {
        state.isOpenChat = isOpenChat
    },
    setClosingChannel (state, channel) {
        state.closingChannel = channel
    },
    setActiveChannels (state, channels) {
        state.activeChannels = channels
    },
    setSelectedDriverChannel (state, channel) {
        state.selectedDriverChannel = channel
    },
    setChatOpenedBy (state, channel) {
        state.chatOpenedByOperator = channel
    },

}
